module.exports = __webpack_public_path__ + "static/media/st-rows.16726b48.svg";